var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4448_179158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22C19.1522 22 21.6957 20.9464 23.5711 19.0711C25.4464 17.1957 26.5 14.6522 26.5 12C26.5 9.34784 25.4464 6.8043 23.5711 4.92893C21.6957 3.05357 19.1522 2 16.5 2C13.8478 2 11.3043 3.05357 9.42893 4.92893C7.55357 6.8043 6.5 9.34784 6.5 12C6.5 14.6522 7.55357 17.1957 9.42893 19.0711C11.3043 20.9464 13.8478 22 16.5 22ZM16.5 22C20.526 22 24.044 23.52 26.546 26.046M16.5 22C8.5 22 2.5 28 2.5 36V46H16.5M46.5 30L40.5 24L28.5 36M35.5 29L41.5 35M20.5 39C20.5005 40.3266 21.028 41.5987 21.9665 42.5364C22.9049 43.474 24.1774 44.0005 25.504 44C26.8306 43.9995 28.1027 43.472 29.0404 42.5335C29.978 41.5951 30.5045 40.3226 30.504 38.996C30.5035 37.6694 29.976 36.3973 29.0375 35.4596C28.0991 34.522 26.8266 33.9955 25.5 33.996C24.1734 33.9965 22.9013 34.524 21.9636 35.4625C21.026 36.4009 20.4995 37.6734 20.5 39Z",
    stroke: "#2A2A2A",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4448_179158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdmin);
export default __webpack_public_path__ + "static/media/user_admin.b50e611ec0be296ac7ae0cd0593decac.svg";
export { ForwardRef as ReactComponent };